import { UploadIcon } from "@heroicons/react/outline"
import React, {  useEffect, useState } from "react"
import { useHistory, useParams } from "react-router-dom"
import { toast} from "react-toastify"
import "react-toastify/dist/ReactToastify.min.css"
import { ENDPOINT, IMAGE_KIT_ENDPOINT_URL, Routes } from "../../../constants"
import {
  Collection,
  CollectionStage,

} from "../../../types"


import { useApi } from "../../../contexts/ApiContext";
import { useAuth } from "../../../contexts/AuthContext";
import { FetchApi } from "../../../api/fetch";
import { getIsJson } from "../../../utils/getIsJson";
import Button from "../../../components/Button";
import ImageSelector from "../../../components/ImageSelector";
import { InputField } from "../../../components/InputField";
import { Notification } from "../../../components/Notification";
import RequestAlert from "../../../components/RequestAlert";
import { useBlockchain } from "../../../contexts/blockchain";


export interface Values {
  walletAddressArray: string[]
  collectionNotes?: string
  collectionName: string
  collectionOwner: string
  collectionId: string
  collectionDescription: string
  websiteLink: string
  twitterLink: string
  teamLink: string
  tiktokLink: string
  instagramLink: string
  mediumLink: string
  roadmapLink: string
  documentationLink: string
  whitepaperLink: string
  discordLink: string
  isNsfw: boolean
  isDerivative: boolean
  isVerifeyed: boolean | undefined
  isMintCalendar: boolean | undefined
  links: any[]
}

interface ManageCollectionFormParams {
  collectionId: string
}

const DeletedCollection = React.memo((props) => {
  const [isReplaceMintList, setIsReplaceMintList] = useState<boolean>()
  const [hasMintList, setHasMintList] = useState(false)

  const [collectionThumbnailUrl, setCollectionThumbnailUrl] = useState<string>()
  const [collectionData, setCollectionData] = useState<Collection>({
    banner_url: "",
    bannerUrl: "",
    links: [],
    collectionId: "",
    collection_id: "",
    collectionKey: "",
    collection_tag_list: [],
    mints: [],
    createdAt: 0,
    creator: "",
    creatorNotes: "",
    description: "",
    mintListUrl: "",
    name: "",
    rejectionNote: "",
    request_id: "",
    id: "",
    special_tag_list: [],
    thumbnailUrl: "",
    thumbnail: "",
    updatedAt: 0,
    keys: [],
    candyMachineAddresses: [],
    walletAddressList: [],
    website: "",
    twitter: "",
    discord: "",
    youtube: "",
    team: "",
    tiktok: "",
    instagram: "",
    medium: "",
    roadmap: "",
    atlas3: "",
    subber: "",
    twitch: "",
    documentation: "",
    whitepaper: "",
    creatorEmail: "",
    mint_list: [],
    publishedEpoch: 0,
    isDerivative: false,
    isNsfw: false,
  })
  const [collectionBannerUrl, setCollectionBannerUrl] = useState<string>()
  const [mintList, setMintList] = useState<string[]>([])
  const [mintHashListName, setMintHashListName] = useState<string>(String)

  const {
    isCurrentUserAdmin,
    setIsLoadingOverlayDisplay,
  } = useAuth()
  const { currentBlockchain }: any = useBlockchain()
  const {
    retrieveDeletedCollections
  } = useApi()
  const { push } = useHistory()
  const isAdmin = isCurrentUserAdmin()
  const { collectionId }: ManageCollectionFormParams = useParams()


  useEffect(() => {
    document?.getElementById("main")?.scrollTo(0, 0)
  }, [])
  useEffect(() => {
    if (collectionId) {
      (async () => {
        setIsLoadingOverlayDisplay(true)
        let collectionFilter: any = await retrieveDeletedCollections({ id: collectionId }, currentBlockchain)

        let collection: Collection = collectionFilter[0]

        const dynamicLinks = collection?.links ? JSON.parse(`${collection?.links}`) : []
        setCollectionData({ ...collection, links: dynamicLinks })
        setHasMintList(Boolean(collection?.mintListUrl))
        if (collection?.thumbnailUrl?.includes("thumbnails/")) {
          setCollectionThumbnailUrl(
            `${IMAGE_KIT_ENDPOINT_URL}${collection?.thumbnailUrl}`
          )
        } else {
          setCollectionThumbnailUrl(collection?.thumbnailUrl)
        }

        setCollectionBannerUrl(collection?.bannerUrl)
        setIsLoadingOverlayDisplay(false)

        if (collection?.mint_list) {
          setMintList(collection?.mint_list)
        }
      })()
    }
  }, [
    collectionId,
  ])


  const deleteCollection = async () => {
    setIsLoadingOverlayDisplay(true)
    const JWT = JSON.parse(sessionStorage.getItem('userData') || '{}').token

    const response = await FetchApi({
      // endpoint: ENDPOINT.SUBMIT_COLLECTION,
      endpoint: `${ENDPOINT.BASE_ENDPOINT}/${collectionId}/erase`,
      method: "DELETE",
      JWT: JWT,
    })
    response && setIsLoadingOverlayDisplay(false)
    response && push(Routes.MANAGE_DELETED)
  }


  const onSelectMintHashList = () => {
    setTimeout(() => {
      document?.getElementById("mintHashListSelector")?.click()
    }, 0)
  }

  const handleMintHashListSelector = (event: any) => {
    const reader = new FileReader()
    const file = event?.target?.files && event?.target?.files[0]
    if (file) {
      reader.onloadend = () => {
        if (getIsJson(reader?.result as string)) {
          setMintHashListName(file.name)
        } else {
          toast.error(
            <Notification
              title="Invalid file"
              description="The Json file provided is either not a Json file or is not formatted correctly."
            />
          )
        }
      }
      reader.readAsText(file)
    }
  }

  return (
    <>
      <div className="flex flex-col w-11/12 mx-auto pb-2">
        <div className="mt-8 flex flex-row items-start mb-8 justify-between flex-col sm:flex-row">
          <div className="w-auto">
            {collectionId && <RequestAlert stage={CollectionStage.deleted} />}
            <h1 className="font-semibold text-3xl text-left mt-8 mb-8">
              MANAGE COLLECTION
            </h1>
          </div>
          {isAdmin && (
            <>
              <Button
                type="button"
                className="mb-0 sm:mb-2 btn bg-red-600"
                onClick={deleteCollection}
              >
                DELETE
              </Button>
            </>
          )}
        </div>

        <form
          onSubmit={() => { }}
          className="flex flex-auto flex-col items-center"
        >
          {isAdmin && (
            <InputField
              disabled
              value={collectionData.creatorEmail}
              name="collectionOwner"
              label="Collection owner"
            />
          )}
          <InputField
            disabled
            value={collectionData?.name}
            required={true}
            name="name"
            label="Collection Name"
          />
          <InputField
            disabled
            value={collectionData?.description}
            name="description"
            label="Collection Description"
            required={true}
          />
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 sm:gap-2 lg:gap-3 w-full">
            <InputField
              disabled
              value={collectionData?.website}
              name="website"
              label="Website Link"
              required={true}
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.discord}
              name="discord"
              label="Discord URL"
              placeholder="eg: https://discord.gg/56PDke6E"
              required={true}
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.roadmap}
              name="roadmap"
              label="Roadmap Link"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.twitter}
              name="twitter"
              label="Twitter / X URL"
              placeholder="eg: https://twitter.com/KyzzenNFT?s=20"
              required={true}
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.whitepaper}
              name="whitepaper"
              label="Whitepaper Link"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.team}
              name="team"
              label="Team URL"
              placeholder="eg: https://team.com/KyzzenNFT?s=20"
              type="url"
            />

            <InputField
              disabled
              value={collectionData?.documentation}
              name="documentation"
              label="Documentation Link"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.instagram}
              name="instagram"
              label="Instagram URL"
              placeholder="eg: https://instagram.com/KyzzenNFT?s=20"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.twitch}
              name="twitch"
              label="Twitch URL"
              placeholder="eg: https://twitch.tv/KyzzenNFT"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.medium}
              name="medium"
              label="Medium URL"
              placeholder="eg: https://medium.com/KyzzenNFT"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.atlas3}
              name="atlas3"
              label="Atlas3 URL"
              placeholder="eg: https://atlas3.io/KyzzenNFT"
              type="url"
            />
            <InputField
              disabled
              value={collectionData?.subber}
              name="subber"
              label="Subber URL"
              placeholder="eg: https://subber.xyz/KyzzenNFT"
              type="url"
            />
            {
              collectionData?.links?.map((item: { link: any; title: any; }, idx: React.Key | null | undefined) => (
                <div className="relative" key={idx}>
                  <InputField
                    type="url"
                    value={item.link}
                    name="links"
                    label={item.title}
                    placeholder="eg: https://example.com"
                    readOnly
                  />
                </div>
              ))
            }
          </div>
          {
            <>
              {" "}
              <div className="flex">
                <Button
                  className="mb-8 mt-10 btn-tab"
                  onClick={() => { setHasMintList(false) }}
                  disabled={!hasMintList}
                >
                  Add Candy Machine ID
                </Button>
                <Button
                  className="mb-8 mt-10 btn-tab"
                  onClick={() => setHasMintList(true)}
                  disabled={hasMintList}
                >
                  Add mint list
                </Button>
              </div>
              {!hasMintList ? (
                <div className="flex flex-col w-full">
                  {collectionData?.walletAddressList?.map((d: any, idx: React.Key | null | undefined) => {
                    return (
                      <div key={idx} className="pt-1 flex">
                        <InputField
                          type="url"
                          value={d}
                          name="walletAddressList"
                          readOnly
                          disabled={true}
                        />
                      </div>
                    )
                  })}
                </div>
              ) : (
                <>
                  <div className="flex flex-col items-center justify-center space-y-4 w-full mt-2">
                    <input
                      style={{ display: "none" }}
                      type="file"
                      accept="application/json"
                      id="mintHashListSelector"
                      onChange={handleMintHashListSelector}
                    />
                    <Button
                      type="button"
                      // disabled={isSubmitting}
                      className="btn flex flex-row items-center"
                      onClick={onSelectMintHashList}
                    >
                      <span>UPLOAD MINT LIST</span>{" "}
                      <UploadIcon className="h-6 w-6 ml-4" />
                    </Button>
                    {mintHashListName && (
                      <div className="text-lg p-2 text-gray-800 bg-gray-200 mr-4 w-full text-left">
                        {mintHashListName}
                      </div>
                    )}
                  </div>
                  <div className="flex-column text-center mt-8 mb-5">
                    <span className="text-lg">
                      Choose what to do with your mint list.
                    </span>
                    <div className="flex justify-center space-x-2">
                      <Button
                        className={`${isReplaceMintList ||
                          isReplaceMintList === undefined
                          ? "bg-gray-700"
                          : "bg-transparent opacity-50"
                          } px-4 py-2 rounded-md mt-2 border-gray-700 border-2 hover:bg-gray-700`}
                        onClick={() => setIsReplaceMintList(true)}
                        disabled={isReplaceMintList}
                      >
                        Replace current mint list
                      </Button>
                      <Button
                        className={`${!isReplaceMintList
                          ? "bg-gray-700"
                          : "bg-transparent opacity-50"
                          } px-4 py-2 rounded-md mt-2 border-gray-700 border-2 hover:bg-gray-700`}
                        onClick={() => setIsReplaceMintList(false)}
                        disabled={isReplaceMintList === false}
                      >
                        Add to current mint list
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </>
          }

          {
            // collectionStage === CollectionStage.live &&
            <div className="flex justify-between">
              {/* {collectionId && <MintHashPreview mintList={mintList} isLoading={isLoadingMintList} />} */}
              {mintList.length > 0 &&
                <a
                  type="button"
                  href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(mintList))}`}
                  download={`${collectionData?.name} mints list.json`}
                  className="btn m-3"
                >
                  {`Download Mint List (.JSON)`}
                </a>
              }
            </div>
          }

          {!collectionId &&
            <div className="p-4 text-gray-600 text-light text-md"
            >
              {`Upload your collection to download the mints list as a .json file`}
            </div>
          }
          {/* {collectionStage && mintList.length < 1 &&
                <div className="p-4 text-gray-600 text-light text-md"
                >
                  {`Your collection has 0 mints. JSON file unavailable`}
                </div>
              } */}

          <div className="w-full mx-auto mb-8 mt-8">
            <input
              style={{ display: "none" }}
              type="file"
              accept=".png, .jpg, .jpeg, .gif"
              id="collectionBannerSelector"
            //   onChange={handleCollectionBannerSelected}
            />
            <input
              style={{ display: "none" }}
              type="file"
              accept=".png, .jpg, .jpeg, .gif"
              id="collectionThumbnailSelector"
            //   onChange={handleCollectionThumbnailSelected}
            />
            <ImageSelector
              imageSrc={
                collectionBannerUrl
              }
              iconSrc={
               collectionThumbnailUrl
              }
            />
          </div>
          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                disabled
                type="checkbox"
                checked={collectionData?.isNsfw}
                name="isNsfw"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">NSFW Collection</label>
          </div>
          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                disabled
                type="checkbox"
                checked={collectionData?.isDerivative}
                name="isDerivative"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">Derivative Collection</label>
          </div>
          <div className="flex justify-start w-full">
            <div className="w-8">
              <InputField
                disabled
                type="checkbox"
                checked={collectionData?.verifeyed}
                name="verifeyed"
                className="form-tick h-8 w-8 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
              />
            </div>
            <label className="text-lg text-left w-full ml-2">Verifeyed Collection</label>

          </div>
        </form>

      </div>
    </>
  )
})

export default DeletedCollection





